import React, { useState } from 'react';
import styled from 'styled-components';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';


const SignUpPage = () => {
    const [focusedField, setFocusedField] = useState(null);
    
  return (
    <div> 
        <Header></Header>
      <Container>
        <LoginForm>
            <h1>Welcome!</h1>
            <Descriction>360도로 펼쳐지는 대한민국,<br/>
            관광부터 맛집까지 생생하게 추천해 드립니다</Descriction>
            <Form>
                <FormGroup focused={focusedField === "id"}>
                    <Label htmlFor="username">아이디</Label>
                    <Input
                        type="text"
                        id="id"
                        name="id"
                        placeholder="아이디를 입력해 주세요"
                        onFocus={() => setFocusedField("id")}
                        onBlur={() => setFocusedField(null)}
                    />
                </FormGroup>
                <ErrorText>이메일 확인용 메세지</ErrorText>
                <FormGroup focused={focusedField === "password"}>
                    <Label htmlFor="password">비밀번호</Label>
                    <Input
                        type="password"
                        id="password"
                        name="password"
                        placeholder="영문, 숫자, 특수문자 포함 8~16자"
                        onFocus={() => setFocusedField("password")}
                        onBlur={() => setFocusedField(null)}
                        style={{marginBottom:'8px'}}
                    />
                    <Input
                        type="password"
                        id="password"
                        name="password"
                        placeholder="비밀번호 확인"
                        onFocus={() => setFocusedField("password")}
                        onBlur={() => setFocusedField(null)}
                    />
                </FormGroup>
                <ErrorText>비밀번호 일치 메세지</ErrorText>
                <FormGroup focused={focusedField === "email"}>
                    <Label htmlFor="username">이메일</Label>
                    <Input
                        type="text"
                        id="email"
                        name="email"
                        placeholder="이메일을 입력해 주세요"
                        onFocus={() => setFocusedField("email")}
                        onBlur={() => setFocusedField(null)}
                    />
                </FormGroup>
                <ErrorText>이메일 확인용 메세지</ErrorText>
                <FormGroup focused={focusedField === "username"}>
                    <Label htmlFor="username">별명</Label>
                    <Input
                        type="text"
                        id="username"
                        name="username"
                        placeholder="사용하실 별명을 입력해 주세요"
                        onFocus={() => setFocusedField("username")}
                        onBlur={() => setFocusedField(null)}
                    />
                </FormGroup>
                <ErrorText>별명 사용 불가 메세지</ErrorText>
                <LoginButton type="submit">가입하기</LoginButton>
              
            </Form>
           
     
  

        </LoginForm>

      </Container>
   <Footer></Footer>
    </div>
  );
};

export default SignUpPage;


const Container  = styled.div`
    width:100%;
    display: flex;
    align-items:center;
    justify-content:center;
`

const LoginForm = styled.div`
    width:638px;
    height:78vh;
    display: flex;
    align-items:center;
    justify-content:center;
    flex-direction: column;
`;

const Descriction = styled.div`
    display: flex;
    align-items:center;
    justify-content:center;
    text-align:center;
    margin-bottom:40px;
    line-height:25px;
`;



// 폼 그룹 스타일
export const Form = styled.form`
    width:430px;
`;

export const FormGroup = styled.div`
    margin-bottom: 5px;
    position: relative;

    input {
        border-color: ${(props) => (props.focused ? "#3C3D37" : "#c1c1c1")};
    }
`;

export const Label = styled.label`
    display: block;
    margin-bottom: 8px;
    font-size: 18px;
    color: #333;
    font-weight:800;
`;

// 입력 필드 스타일
export const Input = styled.input`
    width: 100%;
    height:40px;
    padding-left:15px;
    font-size: 14px;
    border: 1px solid #c1c1c1;
    border-radius: 4px;
    outline: none;
    transition: border-color 0.3s ease-in-out;

    &:focus {
        border-color: #3C3D37;
    }
`;

// 로그인 버튼 스타일
export const LoginButton = styled.button`
    margin-bottom:15px;
    width: 100%;
  
    height:40px;
    font-size: 16px;
    color: #fff;
    background-color: #3C3D37;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;

    &:hover {
        background-color: #2e2e2b;
    }
`;

export const LoginKakaoButton = styled.button`
    margin-bottom:15px;
    width: 100%;
    height:56px;
    font-size: 16px;
    color:#191919;
    background-color: #FEE500;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;

    &:hover {
        background-color: #F9D933;
    }
`;

export const LoginGoogleButton = styled.button`
    margin-bottom:15px;
    width: 100%;
    height:56px;
    font-size: 16px;
    border: 1px solid #747775;
    background-color: white;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;

    &:hover {
        background-color: #c1c1c1;
    }
`;

const Hr = styled.div`
    width:98%;
    border: 1px solid #3C3D37;
    margin-bottom:15px;
`;

const ErrorText = styled.div`
    width:100%;
    height:30px;
    font-size:10px;
    color: gray;

`